import React from 'react';
import { PoolDetail, PoolStatus } from '@/types/pool';
import { hasCounterOffer } from '@/utils/poolStatus';
import { Button } from '../../ui/Button';

type PoolInvestorActionsProps = {
  pool: PoolDetail | null;
  onOffer: () => void;
  onCounterOffer: () => void;
  onWithdrawOffer: () => void;
  onWithdrawCounterOffer: () => void;
};

export const PoolInvestorActions: React.FC<PoolInvestorActionsProps> = ({
  pool,
  onOffer,
  onCounterOffer,
  onWithdrawOffer,
  onWithdrawCounterOffer,
}) => {
  const showOfferButton = pool?.status === PoolStatus.AWAITING_INVESTORS && !hasCounterOffer(pool?.offers);
  const showCounterOfferButton = pool?.status === PoolStatus.AWAITING_INVESTORS && !hasCounterOffer(pool?.offers);
  const withdrawOfferButton = pool?.status === PoolStatus.OFFER_RECEIVED && !hasCounterOffer(pool?.offers);
  const withdrawCounterOfferButton = pool?.status === PoolStatus.AWAITING_INVESTORS && hasCounterOffer(pool?.offers);

  return (
    <div className="flex gap-2 items-center justify-center w-full">
      {showOfferButton && (
        <Button onClick={onOffer} variant="primary">
          Accept Terms & Invest
        </Button>
      )}
      {showCounterOfferButton && (
        <Button onClick={onCounterOffer} variant="secondary">
          Make Counteroffer
        </Button>
      )}

      {withdrawOfferButton && (
        <Button onClick={onWithdrawOffer} variant="dangerText">
          Withdraw offer
        </Button>
      )}

      {withdrawCounterOfferButton && (
        <Button onClick={onWithdrawCounterOffer} variant="dangerText">
          Cancel offer
        </Button>
      )}
    </div>
  );
};
